import React, { Component } from 'react';
import { Link as NativeLink, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Logger } from '../../utils/logger';
import { PathGenerator } from "../../constants/path";

declare var UIkit;

class LinkComponent extends Component {

  onClick = (event) => {
    if( this.props.ga != null){
      Logger.event(this.props.ga);
    }
    this.props.onClick && this.props.onClick(event);
  }

  getIntlLink = () => {
    return this.props.to;
  }

  render = () => {
    var { onClick, to, refresh, ... props } = this.props;
    if(to == null){
      return (
        <a onClick={this.onClick} {...props}>
          { this.props.children }
        </a>
      );
    }else {
      return (
        <NativeLink ref={link => this.link = link} onClick={this.onClick} {...props} to={ this.getIntlLink() }>
          { this.props.children }
        </NativeLink>
      );  
    }
  }
}

const mapStateToProps = state => {
    return {
    };
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
    }, dispatch)
});

export const Link = connect(mapStateToProps, mapDispatchToProps,null, { withRef: true })(LinkComponent);




class ButtonComponent extends Component {

  onClick = (event) => {
    if( this.props.ga != null){
      Logger.event(this.props.ga);
    }
    this.props.onClick && this.props.onClick(event);
  }

  render = () => {
    var props = Object.assign({}, this.props);
    delete props.onClick;

    if( props.loading ){
      return (
        <button {...props} disabled>
          <span data-uk-uk-spinner className="uk-margin-small-right" />
        </button>
      );
    }

    return (
      <button onClick={this.onClick} {...props}>
        { this.props.children }
      </button>
    );
  }
}

export const Button = connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(ButtonComponent);